import React, { useState, useEffect } from 'react';
import '../assets/css/LandingPage.css';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  const slides = [
    {
      title: "Innovative Digital Solutions",
      subtitle: "Transforming businesses with cutting-edge technology and custom software development",
    },
    {
      title: "Web & Mobile Development",
      subtitle: "Creating responsive websites and powerful mobile applications that drive growth",
    },
    {
      title: "AI & Machine Learning",
      subtitle: "Leveraging artificial intelligence to solve complex business challenges",
    }
  ];

  useEffect(() => {
    setIsVisible(true);
    
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    const handleMouseMove = (e) => {
      setMousePosition({
        x: (e.clientX / window.innerWidth) * 100,
        y: (e.clientY / window.innerHeight) * 100
      });
    };

    window.addEventListener('mousemove', handleMouseMove);

    return () => {
      clearInterval(interval);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, [slides.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="hero-section">
      {/* Galaxy Background Animation */}
      <div className="galaxy-background">
        <div className="stars"></div>
        <div className="stars-small"></div>
        <div className="nebula"></div>
        <div className="cosmic-dust"></div>
      </div>

      {/* Animated Grid System */}
      <div className="animated-grid">
        <div className="grid-line horizontal"></div>
        <div className="grid-line vertical"></div>
        <div className="grid-dots"></div>
      </div>

      {/* Floating Particles */}
      <div className="particles-container">
        {[...Array(25)].map((_, i) => (
          <div
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${15 + Math.random() * 20}s`
            }}
          />
        ))}
      </div>

      {/* Geometric Shapes */}
      <div className="geometric-shapes">
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
        <div className="shape shape-3"></div>
        <div className="shape shape-4"></div>
        <div className="shape shape-5"></div>
      </div>

      {/* Mouse Follow Gradient */}
      <div 
        className="mouse-gradient"
        style={{
          background: `radial-gradient(circle at ${mousePosition.x}% ${mousePosition.y}%, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 50%)`
        }}
      />

      <div className="container">
        <div className="hero-content d-flex flex-md-row flex-column align-items-center justify-content-between">
          {/* Main Content */}
          <div className={`content-wrapper ${isVisible ? 'visible' : ''}`}>
            <div className="badge" data-aos="fade-down">
              <div className="badge-dot"></div>
              <span>Techsol Technologies</span>
              <div className="badge-glow"></div>
            </div>

            <h1 className="hero-title-tech" data-aos="fade-up" data-aos-delay="200">
              <span className="title-line">
                <span className="text-reveal">Transforming Ideas</span>
              </span>
              <span className="title-line">
                <span className="text-reveal delay">Into Digital Reality..</span>
              </span>
            </h1>
          </div>

          {/* Right Side - Visual Elements */}
          <div className="hero-visual" data-aos="fade-left" data-aos-delay="400">
            <div className="floating-card card-1">
              <div className="card-glow"></div>
              <div className="card-icon">💻</div>
              <span>Web Development</span>
            </div>
            <div className="floating-card card-2">
              <div className="card-glow"></div>
              <div className="card-icon">📱</div>
              <span>Mobile Apps</span>
            </div>
            <div className="floating-card card-3">
              <div className="card-glow"></div>
              <div className="card-icon">🤖</div>
              <span>AI Solutions</span>
            </div>
            <div className="floating-card card-4">
              <div className="card-glow"></div>
              <div className="card-icon">🤖</div>
              <span>API Development</span>
            </div>
            
            <div className="main-visual">
              <div className="visual-glow"></div>
              <div className="visual-container">
                <div className="code-window">
                  <div className="window-header">
                    <div className="window-dots">
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                    <div className="window-title">innovation.js</div>
                  </div>
                  <div className="code-content">
                    <div className="code-line">
                      <span className="code-keyword">const</span>
                      <span className="code-variable"> innovation</span>
                      <span className="code-operator"> = </span>
                      <span className="code-string">"Techsol Technologies"</span>
                    </div>
                    <div className="code-line">
                      <span className="code-keyword">while</span>
                      <span className="code-bracket">(</span>
                      <span className="code-variable">success</span>
                      <span className="code-operator">)</span>
                      <span className="code-bracket">{` {`}</span>
                    </div>
                    <div className="code-line">
                      <span className="code-text">  deliverExcellence</span>
                      <span className="code-bracket">()</span>
                    </div>
                    <div className="code-line">
                      <span className="code-bracket">{`}`}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slide Controls */}
        <div className="slide-controls d-none">
          <button className="control-btn prev" onClick={prevSlide}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
            </svg>
          </button>
          
          <div className="slide-indicators">
            {slides.map((_, index) => (
              <button
                key={index}
                className={`indicator ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
          
          <button className="control-btn next" onClick={nextSlide}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"/>
            </svg>
          </button>
        </div>

        {/* Scroll Indicator */}
        <div className="scroll-indicator d-none">
          <div className="scroll-line"></div>
          <span>Scroll to explore</span>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;